export class RolePermissionsType {
    public static ADMINISTRATOR = "a";

    public static PUBLISHER_ADMINISTRATOR = "pa";
    public static PUBLISHER_PUBLISH = "be";
    public static PUBLISHER = "p";
    public static PUBLISHER_FACEBOOK_READ = "ba";
    public static PUBLISHER_INSTAGRAM_PAGE_READ = "bb";
    public static PUBLISHER_TWITTER_READ = "bc";

    public static ACCOUNT_MANAGE = "g";
    public static INVITATIONS_MANAGE = "k";
    public static ROLES_MANAGE = "n";

    public static BLOG_ADMINISTRATOR = "bi";
    public static BLOG_READING = "bj";
    public static BLOG_WRITING = "bk";
    public static BLOG_PUBLISH = "bt";
    public static BLOG_DELETE = "bl";

    public static SUBSCRIPTION_ADMINISTRATOR = "bm";
}